import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { navContextSearchSchema } from '~/features/catalog-v2/utils/nav-context';

const ProductMasterDetailPage = lazy(
  () => import('~/features/catalog-v2/pages/product-master-detail-page'),
);

/** S8 — `from`/`back` carry where a cross-section link sent the user here, so the page can show
 *  an origin breadcrumb prefix and a "← Back to <origin>" chip instead of landing with no trace
 *  of the batch/queue/experiment that linked here. */
const searchSchema = z.object({ ...navContextSearchSchema });

export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/products/$productId')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { productId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ProductMasterDetailPage productId={productId} />
    </Suspense>
  );
}
